import { FraudActionType, FraudStatus } from 'src/types/fraudWatch.type';
import base from './baseApi';

const { urls, methods, execute } = base();

/** `page` is 0-based, matching the shared `getListByFilter()` contract on the API. */
export type FraudQueueParams = {
   page: number;
   limit: number;
   fraudStatus?: FraudStatus;
};

export type FraudActionPayload = {
   userId: string;
   action: FraudActionType;
   note: string;
};

const header = {
   authorization: true,
};

export const getFraudQueue = ({ page, limit, fraudStatus }: FraudQueueParams) => {
   return execute(methods.GET, urls.fraudWatch.index, header, { page, limit, fraudStatus });
};

export const getFraudUserDetail = (userId: string) => {
   return execute(methods.GET, urls.fraudWatch.getById.replace(':userId', userId), header);
};

export const getFraudOpenCount = () => {
   return execute(methods.GET, urls.fraudWatch.count, header);
};

export const postFraudAction = ({ userId, action, note }: FraudActionPayload) => {
   const url = urls.fraudWatch.action.replace(':userId', userId).replace(':action', action);

   return execute(methods.POST, url, header, { note });
};
